import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  ReleasePokemonInput,
  ReleasePokemonOutput,
  WebAppRoutes,
} from "types/web-app";

export const releasePokemon = async (
  accessToken: string,
  input: ReleasePokemonInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.RELEASE_POKEMON,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<ReleasePokemonOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
